var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLinkedinLogo = function SvgIconLinkedinLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.625 10.25a1 1 0 0 1 .846.467 3.625 3.625 0 0 1 5.404 3.158V16.5a1 1 0 1 1-2 0v-2.625a1.625 1.625 0 1 0-3.25 0V16.5a1 1 0 1 1-2 0v-5.25a1 1 0 0 1 1-1M8.875 11.25a1 1 0 1 0-2 0v5.25a1 1 0 1 0 2 0zM9.375 7.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.375 4.125c0-.966.784-1.75 1.75-1.75h15.75c.966 0 1.75.784 1.75 1.75v15.75a1.75 1.75 0 0 1-1.75 1.75H4.125a1.75 1.75 0 0 1-1.75-1.75zm2 .25v15.25h15.25V4.375z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconLinkedinLogo;